import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { X } from 'lucide-react';

interface SyncOrdersModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSync: (options: SyncOptions) => void;
}

export interface SyncOptions {
  syncType: 'all' | 'fromDate';
  fromDate?: string;
}

export default function SyncOrdersModal({ isOpen, onClose, onSync }: SyncOrdersModalProps) {
  const [syncType, setSyncType] = useState<'all' | 'fromDate'>('all');
  const [fromDate, setFromDate] = useState<string>('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSync({
      syncType,
      fromDate: syncType === 'fromDate' ? fromDate : undefined
    });
    onClose();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 z-50 overflow-y-auto"
    >
      <div className="flex items-center justify-center min-h-screen">
        <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />

        <div className="relative bg-white rounded-lg p-6 max-w-md w-full mx-4">
          <div className="absolute top-4 right-4">
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-500"
            >
              <X size={20} />
            </button>
          </div>

          <Dialog.Title className="text-lg font-medium mb-4">
            Sincronizar Encomendas
          </Dialog.Title>

          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  id="syncAll"
                  name="syncType"
                  value="all"
                  checked={syncType === 'all'}
                  onChange={(e) => setSyncType(e.target.value as 'all' | 'fromDate')}
                  className="text-primary focus:ring-primary"
                />
                <label htmlFor="syncAll">Sincronizar todas as encomendas</label>
              </div>

              <div className="flex items-center space-x-2">
                <input
                  type="radio"
                  id="syncFromDate"
                  name="syncType"
                  value="fromDate"
                  checked={syncType === 'fromDate'}
                  onChange={(e) => setSyncType(e.target.value as 'all' | 'fromDate')}
                  className="text-primary focus:ring-primary"
                />
                <label htmlFor="syncFromDate">Sincronizar a partir de uma data</label>
              </div>

              {syncType === 'fromDate' && (
                <div className="mt-2">
                  <input
                    type="date"
                    value={fromDate}
                    onChange={(e) => setFromDate(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-primary focus:border-primary"
                    required={syncType === 'fromDate'}
                  />
                </div>
              )}
            </div>

            <div className="mt-6 flex justify-end space-x-3">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200"
              >
                Cancelar
              </button>
              <button
                type="submit"
                className="px-4 py-2 text-sm font-medium text-white bg-primary rounded-md hover:bg-primary-dark"
              >
                Sincronizar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Dialog>
  );
}
